module.exports = __webpack_public_path__ + "img/vertical_7_2_9006.980e6d2b.png";